<template>
    <Sections class="videos">
        <SectionText
            padding="py-8 sm:py-10"
            :heading="heading"
            :content="collectionUi ? undefined : '<p></p>'"
            color="bg-zinc-100"
        >
            <template v-slot:custom>
                <div v-if="!collectionUi">
                    <ContainerVideosRefineDesktop
                        class="hidden lg:block"
                        v-bind="{
                            orders,
                            order,
                            showMobileMenu,
                            filters,

                            updateSortOrder,
                            updateFilterCurrentValue,
                            toggleMobileMenu,
                            setShowMobileMenu,
                        }"
                    ></ContainerVideosRefineDesktop>
                    <ContainerVideosRefineMobile
                        class="block lg:hidden"
                        v-bind="{
                            selected,
                            orders,
                            order,
                            showMobileMenu,
                            categoryValue,
                            filters,

                            // Methods
                            updateSortOrder,
                            toggleMobileMenu,
                            setShowMobileMenu,
                            updateFilterCurrentValue,
                        }"
                    ></ContainerVideosRefineMobile>
                    <ContainerVideosFilterActiveChips
                        class="lg:mt-1"
                        v-bind="{selected, toggleSelection, clearAll}"
                    ></ContainerVideosFilterActiveChips>
                    <LayoutSearchBar
                        placeholder="Search videos..."
                        :makeSearch="setQuery"
                        :searchQuery="query"
                        :shouldFocus="shouldFocus"
                        class="mt-2 lg:mb-2 lg:mt-5"
                    ></LayoutSearchBar>
                </div>
            </template>
        </SectionText>
        <SectionLoadingList
            v-if="!hasMore"
            thing="videos"
            :results="lessons"
            :error="error"
            padding="py-10"
        ></SectionLoadingList>
        <SectionCards
            v-if="lessons?.length"
            padding="py-12"
            :contentful="true"
            :cards="lessons?.map(lesson => ({
                route: useContextLesson().routeSearch(lesson),
                image: lesson.lesson_image_url,
                imageAlt: 'The main image for this music lesson',
                heading: lesson.lesson_title,
                imageAspectRatio: 'aspect-[40/21] object-cover object-center',
                imageOverlayLocked: isPremiumMember ? null : lesson.lesson_locked,
                excerpt: lesson.lesson_subtitle,
                content: videoMetaItems(
                    lesson.lesson_difficulty,
                    lesson.lesson_genre,
                    lesson.lesson_decade,
                    lesson.lesson_instrument
                ),
                buttonText: 'Watch Now',
            }))"
            :useHover="true"
        ></SectionCards>
        <LayoutInfiniteScroll
            :hasMore="hasMore"
            :loadMore="loadMore"
        ></LayoutInfiniteScroll>
    </Sections>
</template>

<script setup>
const {$config} = useNuxtApp();
const route = useRoute();
useSeo().buildHead({
    title: 'Videos | ' + $config.public.siteName,
    description: 'Browse videos on the Andy Guitar website.',
    index: true,
});

const shouldFocus = computed(() => !!route?.query?.focus);

const videoMetaItems = (difficulty, genre, decade, instrument) => [
    difficulty,
    instrument && `${instrument}${instrument !== 'Ukulele' ? ' Guitar' : ''}`,
    decade,
    genre !== 'Acoustic' && genre
].filter(Boolean).join(', ');

const {currentUser} = storeToRefs(useStoreAuth());
const {
    error,
    lessons,
    hasMore,
    selected,
    orders,
    order,
    query,
    categoryValue,
    showMobileMenu,
    filters,
} = storeToRefs(useStoreVideosSearch());

const heading = computed(() => {
    const queryTitle = route.query.title || null;
    const queryUi = route.query.ui || null;

    if (queryTitle) return queryTitle;
    if (queryUi !== 'collection') return 'Videos';
    if (!selected.value?.length) return 'Videos';
    return selected.value[0].value;
});

const isPremiumMember = computed(() => {
    return !!currentUser.value?.has_aaa_membership;
});

const collectionUi = computed(() => {
    return route?.query?.ui === 'collection';
});

const {
    init,
    loadMore,
    clearAll,
    updateSortOrder,
    updateFilterCurrentValue,
    setQuery,
    toggleSelection,
    toggleMobileMenu,
    setShowMobileMenu,
    updateQueryString,
} = useStoreVideosSearch();

await useLazyAsyncData('load', () => init().then(() => true));
onMounted(updateQueryString);

</script>
